import React, { useCallback, useEffect, useState } from "react";
import { NavFrame } from "./frames/navframe";
import SideFrame from "./frames/sideframe";
import SummaryTabWrap from "./tabs/summary/summarytabwrap";
import LabsWrap from "./tabs/labs/labsWrap";
import Procedures from "./tabs/procedure/procedure";
import PriorVisit from "./tabs/priorvisits/priorvisit";
import Vitals from "./tabs/vitals/vitals";
import RPM from "./tabs/rpm/rpm";
import Imaging from "./tabs/imaging/imaging";
import { Form } from "./tabs/forms/form";
import Document from "./tabs/Document/document";
import dayjs from "dayjs";
import CCmTable from "./tabs/ccm/ccm";
import api from "../../api/api";
import Refillstab from "../../orders/tabs/refills";
import ChatWrapper from "../../header/chat/chatwrapper";
import { eventBus } from "../../utils/eventBus";
import Editscreen from "../../blinkscribe/archeivescreens/editscreen";
import ChartRecordingNudge from "./ChartRecordingNudge";
import PulseChat from "./frames/PulseChat";
import blinkscribeapi from "../../api/blinkscribeapi";
import Threads from "./tabs/nonvisitnotes/threads";
import CareIQTab from "./tabs/careiq/CareIQTab";
import { bsAccessGated, chartDefaultTab, chartTab, getPracticeId } from "../../config/practice";
import { useBsAccess } from "../../utils/bsAccess";
import "./frames/chartframe.css";

const PateintsChartsWrapper = ({data ,dob,onClose,fetchpcarddata,setFetchedData, isloaderactive,fetchedData,searchdate}) => {
  // CareIQ is the default chart tab (Summary retired — matches care-sandbox);
  // a practice with a chart tab allowlist opens on its first tab (7825: Vitals).
  const [currentTab, setCurrentTabRaw] = useState(() => chartDefaultTab(11));
  // Every tab change goes through the practice's allowlist (config/practice.js
  // chartTab): a tab it leaves out opens the chart's first tab instead. 9928
  // has no list, so this is setCurrentTabRaw itself.
  const setCurrentTab = useCallback((tab) => setCurrentTabRaw(chartTab(tab)), []);
  const [pendingResults, setPendingResults] = useState([]);
  const[internalnav,setInternaNav]=useState(false)
  const [vitalsinternav,setVitalsInternav]=useState(0)
  const[isreocrdingdisabled,setIsRecordingDisabled]=useState(false)
    const [hasRpmAccess, setHasRpmAccess] = useState(false);
    // Note editor opened from LiveScribePanel's "Edit" button (via eventBus).
    const [editRecord, setEditRecord] = useState(null);
    // Whether today's appointment already has a note — suppresses the nudge.
    const [hasExistingNote, setHasExistingNote] = useState(false);
    // Pulse chart-assistant panel, toggled from the nav bar avatar.
    const [pulseOpen, setPulseOpen] = useState(false);
    // Chart chrome (top bar): patient panel rail vs expanded, and the
    // CareIQ timeline panel.
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [showTimeline, setShowTimeline] = useState(true);
    // OSA batch 6 (7825): no recording nudge for a user known to have no
    // BlinkScribe in the practice (9928 never checks).
    const bsAccess = useBsAccess();
    const nudgeHidden = bsAccessGated() && bsAccess === "no";
    const practiseid = getPracticeId();
      const [chat,setChat]=useState(false)
const audiotabchange=()=>{
setInternaNav(1)
setCurrentTab(5)

}
const formatDate = (dateString) => {
  return dayjs(dateString).format("YYYY-MM-DD");
};

useEffect(() => {
  const handleNavigateToPriorVisit = (payload) => {
    if (payload?.tab !== undefined) {
      setCurrentTab(payload.tab);
    }
    if (payload?.internalTab !== undefined) {
      setInternaNav(payload.internalTab);
    }
  };

  eventBus.on("navigateToPriorVisit", handleNavigateToPriorVisit);

  return () => {
    eventBus.off("navigateToPriorVisit", handleNavigateToPriorVisit);
  };
}, []);

// LiveScribePanel's "Edit" button emits openNoteEditor; without this listener
// the click does nothing at all (the event had no subscriber in cloud2).
useEffect(() => {
  const handleOpenNoteEditor = (payload) => {
    if (payload?.recordingId) {
      setEditRecord({ id: payload.recordingId });
    }
  };
  eventBus.on("openNoteEditor", handleOpenNoteEditor);
  return () => { eventBus.off("openNoteEditor", handleOpenNoteEditor); };
}, []);

// Does today's appointment already have a note? Drives the recording nudge so
// a provider who has already documented the visit isn't nagged. Re-runs when a
// recording finishes (refreshDashboard).
useEffect(() => {
  if (!data?.patientid) return;
  let cancelled = false;
  const fetchHasNote = async () => {
    try {
      const t = new Date();
      const iso = `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
      const res = await blinkscribeapi.post(
        `/v1/patient/${data.patientid}/recording/details`,
        { filter_array: { date_filter: { start_date: iso, end_date: iso } } }
      );
      if (cancelled) return;
      const records = res?.data || res || [];
      const apptId = data?.appointmentid;
      setHasExistingNote(Array.isArray(records) && records.some((r) => {
        if (!r) return false;
        if (apptId && r.config_appointmentid &&
            String(r.config_appointmentid) !== String(apptId)) return false;
        return r.transcriptionstatus === "Summarized" || r.transcriptionstatus === "APPROVED";
      }));
    } catch (_) {
      // Non-blocking: keep the previous value rather than nagging because of a
      // transient API failure.
    }
  };
  fetchHasNote();
  eventBus.on("refreshDashboard", fetchHasNote);
  return () => {
    cancelled = true;
    eventBus.off("refreshDashboard", fetchHasNote);
  };
}, [data?.patientid, data?.appointmentid]);
useEffect(() => {
  const handleNavigateTovitals= (payload) => {
    if (payload?.tab !== undefined) {
      setCurrentTab(payload.tab);
    }
    if (payload?.internalTab !== undefined) {
      setVitalsInternav(payload.internalTab);
    }
  };

  eventBus.on("navigateToPriorVitals", handleNavigateTovitals);

  return () => {
    eventBus.off("navigateToPriorVitals", handleNavigateTovitals);
  };
}, []);

// Listen for thread notification navigation
useEffect(() => {
  const handleNavigateToThreads = (payload) => {
    if (payload?.tab !== undefined) {
      setCurrentTab(payload.tab);
    }
  };

  eventBus.on("navigateToThreadsTab", handleNavigateToThreads);

  return () => {
    eventBus.off("navigateToThreadsTab", handleNavigateToThreads);
  };
}, []);

const fetchuserrpm=async()=>{
  try {
    const response=await api.get(`/v1/${practiseid}/patient/${data?.patientid}/rpm/get-rpm-patient`)
  
    if(response.status===200){
setHasRpmAccess(response?.rpm_status||false);
    }else{
      setHasRpmAccess(false);
    }
  } catch (error) {
    console.log(error)
  }
}
useEffect(()=>{
if(data?.patientid){
  fetchuserrpm()
}
},[data])

  const renderContent = () => {
    switch (currentTab) {

      case 0:
        return <SummaryTabWrap isloaderactive={isloaderactive}dataId={data} setFetchedData={setFetchedData}
             fetchedData={fetchedData} searchdate={formatDate(data?.startdate)} />;
      case 1:
        return <LabsWrap dataId={data} />;
      case 2:
        return <Document dataId={data} searchdate={formatDate(data?.startdate)} />;
        case 3:
          return <Vitals vitalsinternav={vitalsinternav} setVitalsInternav={setVitalsInternav} dataId={data} setFetchedData={setFetchedData} />;
          case 4:
            return hasRpmAccess ? <RPM dataId={data} /> : null;
        case 5:
          return <PriorVisit internavtab={internalnav} dataId={data} searchdate={formatDate(data?.startdate)} />;
        
        case 6: 
        return <Imaging data={{ 
  ...data, 
  ...(dob && { dob }) 
}}

           />
           case 7:
            return <Form  
            data={data}
            searchdate={formatDate(data?.startdate)}
            />

            case 8:
              return <CCmTable setIsRecordingDisabled={setIsRecordingDisabled}  data={data}
            searchdate={formatDate(data?.startdate)}/>
            case 9:
              return <div className="max-h-[80vh] overflow-auto">


                  <Refillstab
                                    data={data}
                                    // setShowOrders={setShowOrders}
                                    // appointmentId={appointmentId}
                                    startDate={formatDate(data?.startdate)}
                                  />
              </div>

              case 10:
                return <div className="max-h-[75vh] overflow-auto">
<Threads  data={data} />

                </div> 
              case 11:
                return <CareIQTab dataId={data} onSwitchTab={setCurrentTab} setPendingResults={setPendingResults} showTimeline={showTimeline} onCloseTimeline={() => setShowTimeline(false)} onToggleTimeline={() => setShowTimeline((v) => !v)} />;
      default:
        return null;
    }
  };

  return (

<div className="bmch-shell flex flex-col md:flex-row w-full">

        <div className={`bmch-sidecol${sidebarCollapsed ? " rail" : ""}`}>
          <SideFrame
            onClose={onClose}
            setChat={setChat}
            fetchpcarddata={fetchpcarddata}
            currentTab={currentTab}
            isreocrdingdisabled={isreocrdingdisabled}
            data={data}
            audiotabchange={audiotabchange}
            setFetchedData={setFetchedData}
            fetchedData={fetchedData}
            collapsed={sidebarCollapsed}
            onToggleCollapse={() => setSidebarCollapsed((v) => !v)}
          />
        </div>
        {/* min-w-0: without it this flex child refuses to shrink below its
            content width and the whole chart scrolls sideways on tablets. */}
        <div className="bmch-maincol flex-grow min-w-0">
          <NavFrame
            activeTab={currentTab}
            onTabClick={(index) => setCurrentTab(index)}
            hasRpmAccess={hasRpmAccess}
            pulseOpen={pulseOpen}
            setPulseOpen={setPulseOpen}
            onClose={onClose}
          />
          <div className={`bmch-content${currentTab === 11 ? " flush" : ""}`}>
            {renderContent()}

          </div>
        </div>        {chat?<ChatWrapper setChat={setChat} patientdata={data} flow={'comment'} />:<></>}
        {pulseOpen && (
          <PulseChat
            patientId={data?.patientid}
            patientName={data?.patientname || data?.patient_name ||
                         `${data?.firstname || ""} ${data?.lastname || ""}`.trim()}
            onClose={() => setPulseOpen(false)}
            onRefClick={(ref) => {
              // Route a citation click to the tab that shows it. cloud2's CareIQ
              // tab is 11 (care's is 10) — the rest of the indices line up.
              if (ref.type === "lab") setCurrentTab(1);
              else if (ref.type === "imaging") setCurrentTab(6);
              else if (ref.type === "medication") setCurrentTab(9);
              else if (ref.type === "encounter" || ref.type === "condition") setCurrentTab(11);
            }}
          />
        )}
        {/* Recording reminder for today's appointment. Emits
            startRecordingFromNudge, which sideframe listens for. Not for a
            user known to have no BlinkScribe in the practice (7825). */}
        {!nudgeHidden && (
        <ChartRecordingNudge
          data={data}
          hasExistingNote={hasExistingNote}
          onStartRecording={() => eventBus.emit("startRecordingFromNudge")}
        />
        )}
        {/* Note editor, opened by LiveScribePanel's Edit button. Editscreen
            portals its own fullscreen overlay to <body> (no wrapper here —
            a second overlay double-dimmed and, inside this transformed
            subtree, anchored to the wrong box). Closed by setIsEditScreen(false). */}
        {editRecord && (
          <Editscreen
            selectedRecord={editRecord}
            // The visit this chart is open for. Editscreen warns + asks before
            // any write when the opened note belongs to a different visit
            // (a save there re-posts to THAT visit's Athena encounter).
            chartAppointmentId={data?.appointmentid}
            setIsEditScreen={(v) => { if (!v) setEditRecord(null); }}
          />
        )}
      </div>

  );
};

export default PateintsChartsWrapper;
